"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("../../../bus/ui/selectors");
var _selectors2 = require("../../../modalDispatcher/store/selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var withLoadingIndicators = function withLoadingIndicators(Component) {
  var WithLoadingIndicators = function WithLoadingIndicators(props) {
    var modalsUIKeys = (0, _reactRedux.useSelector)(_selectors2.getModalsKeys);
    var isVisibleGlobalLoader = (0, _reactRedux.useSelector)(_selectors.getIsVisibleGlobalLoader);
    var getUIsForModals = (0, _react.useMemo)(function () {
      return R.partialRight((0, _selectors.getUIs)(), [{
        keys: modalsUIKeys
      }]);
    }, [modalsUIKeys]);
    var uis = (0, _reactRedux.useSelector)(getUIsForModals);
    var isLoading = (0, _react.useMemo)(function () {
      return R.any(R.prop('loading'), uis);
    }, [uis]);
    return (isLoading || isVisibleGlobalLoader) && /*#__PURE__*/_react.default.createElement(Component, props);
  };
  return WithLoadingIndicators;
};
var _default = exports.default = withLoadingIndicators;